<rt-icons-container></rt-icons-container>

<rtc-detached-router-outlet></rtc-detached-router-outlet>
